import React, { useState, useEffect } from 'react';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
const { SingleArrowBlackExpand, SingleArrowBlack } = IMAGE_PATH;
/**
 *  Accordion Component
 * @param {*} props - Object
 */

const CustomDropdown = props => {
  const {
    cssClass,
    dropdownTitle,
    setSelectedItem,
    selectedItem,
    options,
    dropdownId,
    changeTimeObj = {},
    changeDateObj = {},
    dateTimeArr = [],
    placeholderText,
    disableOptions = false,
  } = props;
  const selectedItemValue = selectedItem?.value || placeholderText;
  const [isOpen, setIsOpen] = useState(false);
  const { setSelectedTime = null, setErrorObj = {} } = changeTimeObj;
  const { setSelectedDate = null } = changeDateObj;
  /* called when user clicks on dropdown option */
  const onSelect = (e, item) => {
    e?.preventDefault();
    e?.stopPropagation();
    setIsOpen(false);
    if (dropdownId === 'time-id') {
      setSelectedItem(item, setSelectedTime, setErrorObj);
    } else {
      setSelectedItem(item, dateTimeArr, setSelectedDate, setSelectedTime, setErrorObj);
    }
  };
  /* called as didmount & to register click eventlistener */
  useEffect(() => {
    const closeDropdown = e => {
      e?.preventDefault();
      e?.stopPropagation();
      if (!e?.target?.matches(`#${dropdownId}`) && !e?.target?.closest(`#${dropdownId}`)) {
        setIsOpen(false);
      }
    };
    window.addEventListener('click', closeDropdown);
    return () => {
      window.removeEventListener('click', closeDropdown);
    };
  }, [dropdownId]);

  return (
    <div className={`custom-dropdown ${cssClass}`}>
      {dropdownTitle && (
        <div className='dropdown-title' aria-level='1' role='heading' tabIndex='0'>
          {dropdownTitle}
        </div>
      )}
      <div
        id={dropdownId}
        className='dropdown-value'
        data-testid='dropdown-value-id'
        role='listbox'
        tabIndex='0'
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className='selected-value'>{selectedItemValue}</div>
        {!disableOptions && (
          <img src={isOpen ? SingleArrowBlackExpand : SingleArrowBlack} alt=' ' className='downarrow-imgs' />
        )}
      </div>
      {!disableOptions && isOpen && (
        <div className='options-container'>
          <ul>
            {options?.map(item => (
              <li
                key={item?.key}
                tabIndex='0'
                onClick={e => onSelect(e, item)}
                className={item?.disabled && 'disabledOption'}
                data-testid='option-id'
              >
                {item?.value}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default CustomDropdown;
